import { Component } from "react";
import {
  popCancelBttn,
  collapseIconNew,
  expandIconNew,
  imsLoader,
} from "../../assets";
import trackingService from "../../services/trackingService";
import { getVarType } from "../GenerateArrayStrings";
import moment from "moment";
import OpenWindow from "../OpenWindow";
import axios from "axios";
import { LocationOrigin, getFormattedAccessGroup } from "../../utils/utilityServices";
import AiNotebookDocumentPreview from "../Preview/AiNotebookDocumentPreview";
import { Modal } from "react-bootstrap";
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
import { isEqual } from "underscore";
import Button from "../Button";
import { Authentication } from "../../utils/authenticationUtilityServices";

let _prodLocationOrigin = "https://ims.jnj.com";
class PubMedDocumentCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customWidth: props.customWidth,
      collapsed: false,
      actionBarCollapsed: false,
      documentIndex: this.props.count,
      item: this.props.item,
      searchKeyword: "",
      appliedFilters: [],
      pageSize: "",
      pageNumber: "",
      isCollapseAll: false,
      searchID: "",
      showAuthoring: false,
      showPreview: false,
      isPreviewProcessing: false,
      sourceItem: null,
      alertMessageModelColor: "",
      alertMessageContent: "",
      alertMessageShowModal: false,
      documentDetailModal: false,
      selectedTab: props.selectedTab,
      isShowMoreAuthor: false
    };
  }
  componentDidMount() {
    this.setState({
      item: this.props.item,
      collapsed: this.props.globalCollapseAll,
      // documentIndex: this.props.documentIndex,
      appliedFilters: this.props.appliedFilters,
      searchKeyword: this.props.searchKeyword,
      pageSize: this.props.pageSize,
      pageNumber: this.props.pageNumber,
      isCollapseAll: this.props.isCollapseAll,
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.globalCollapseAll !== prevProps.globalCollapseAll) {
      this.setState({ collapsed: this.props.globalCollapseAll });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.collapsedAll !== undefined) {
      let data = this.props.collapsedAll;
      let index = this.props.resultsIndex;
      if (data[index]) {
        this.setState({ collapsed: data[index] });
      } else {
        this.setState({ collapsed: data[index] });
      }
    }
    if (!isEqual(this.props.item, nextProps.item)) {
      this.setState({
        item: nextProps.item,
      });
    }
  }
  successAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#00c12c",
      alertMessageShowModal: true,
    });
  };
  errorAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#de1327",
      alertMessageShowModal: true,
    });
  };
  closeAlertMessage = () => {
    this.setState({
      alertMessageContent: "",
      alertMessageModelColor: "",
      alertMessageShowModal: false,
      showPreview: false,
    });
  };
  indexPubMedData = (event, state, url) => {
    var title = [event.target.getAttribute("data-title")];
    var docUrl = [event.target.getAttribute("data-docurl")];
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem("companyname"),
      "View OR Download PubMed Document",
      "Direct",
      window.location.href,
      this.state.searchKeyword,
      this.state.appliedFilters,
      title,
      "",
      "",
      "",
      docUrl,
      "",
      "",
      "View PubMed Document",
      this.props.csPath !== null ? this.props.csPath : "",
      this.props.csproduct !== null ? this.props.csproduct : "",
      "PubMed",
      this.props.pageNumber,
      this.props.pageSize,
      ""
    );

    if (state?.item?.PMID) {
      window.open(url, "_target", "rel=noopener noreferrer");
    } else {
      this.setState({
        ...this.state,
        documentDetailModal: true,
      });
    }
  };
  handleExpandCollapse = () => {
    const collapsed = !this.state.collapsed;
    this.setState({ collapsed: !this.state.collapsed }, () => {
      this.props.manageCollapseAndExpand(collapsed, this.state.item.rli_id);

    });
  };
  handelCitationSelect = (documentIndex, item, itemTeaser) => {
    this.props.handleCitationSelection(documentIndex, item, itemTeaser);
  };
  handleUnpin = (item) => {
    this.props.handleUnpin(item);
  };
  citationUrl = (url) => {
    this.props.citationUrl(url);
  };
  handleDOI = (doi) => {
    let url = `https://doi.org/${doi}`;
    OpenWindow(url);
  };
  handlePubMedID = (pmID) => {
    let url = `https://pubmed.ncbi.nlm.nih.gov/${pmID}/?otool=pajanslib`;
    OpenWindow(url);
  };
  handlePubMedPMCID = (pmcID) => {
    let url = `https://pmc.ncbi.nlm.nih.gov/articles/${pmcID}/`;
    OpenWindow(url);
  };
  runSearch = async () => {
    this.setState({ isPreviewProcessing: true });
    const pmidQueryParams = this.state.item.PMID;
    let userAccessGroup = JSON.parse(localStorage.getItem("accessgroup"));
    var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}qp/runSearch`
    if (window.location.origin === "https://predev-ims.jnj.com" ||
      window.location.origin === "https://stage-ims.jnj.com" ||
      window.location.origin === "http://localhost:3000") {
      url = `${_prodLocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}qp/runSearch`;
    }
    var config;
    const _headers = {
      "Content-Type": "application/json"
    }
    if (await Authentication.isAccessTokenAvailable()) {
      const token = await Authentication.getAccessToken();
      _headers.Authorization = `Bearer ${token}`;
    }
    config = {
      method: "POST",
      url: url,
      headers: _headers,
      data: {
        query: "",
        boolean: false,
        filters: "",
        function: localStorage.getItem("function").replace(/"/g, ""),
        doctypepref: "",
        userproducts: localStorage.getItem("userproducts"),
        region: localStorage.getItem("region"),
        username: localStorage
          .getItem("username")
          .toLowerCase()
          .replace(/"/g, ""),
        contentpreference: localStorage
          .getItem("contentpreference")
          .replace(/"/g, ""),
        from: 0,
        size: 25,
        f1: "pmID",
        fval1: `${pmidQueryParams}`,
        fcount: 1,
        accessGroup: getFormattedAccessGroup(userAccessGroup),
        // "source": "searchID"
      },
    };

    await axios(config)
      .then((response) => {
        if (response.data.body.hits.total.value > 0) {
          if (response.data.body.hits.hits[0]._source) {
            this.setState({
              searchID: response.data.body.hits.hits[0]._source.searchID,
              sourceItem: response.data.body.hits.hits[0]._source,
            });
            this.setState({ showAuthoring: true });
          } else if (this.state.item?.doi) {
            this.handleDOI(this.state.item.doi);
          } else {
            this.errorAlertMessage("Preview unavailable for this document.");
          }
        } else if (this.state.item?.doi) {
          this.handleDOI(this.state.item.doi);
        } else {
          this.errorAlertMessage("Preview unavailable for this document.");
        }
      })
      .catch(function (error) {
        this.errorAlertMessage(
          "Something Went Wrong. Kindly try after some time."
        );
        //console.log(error);
      })
      .finally(async () => {
        this.setState({ isPreviewProcessing: false });
        // setProcessing(false)
      });
  };
  handlePreviewByPubMedID = async (e, pmID) => {
    // if (this.state.searchID) {
    //   this.setState({ showAuthoring: true });
    // }
    if (pmID) {
      await this.runSearch();
      if (this.state.searchID && this.state.sourceItem) {
        this.setState({ showAuthoring: true });
      }
      // else if (this.state.item?.doi) {
      //   this.handleDOI(this.state.item.doi);
      // }
      // else {
      //   this.errorAlertMessage("Preview unavailable for this document.");
      // }
    } else {
      this.handleDOI(this.state.item.doi);
    }
  };
  handlePreviewClose = (status) => {
    this.setState({ showAuthoring: false, showPreview: false });
  };
  renderModelPopup = () => {
    let { showPreview, showAuthoring, sourceItem, customWidth } = this.state;
    return (
      <Modal
        show={showPreview || showAuthoring}
        size="xl"
        centered
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="authoring-popup-transition"
        className="z-index-preview"
        backdropClassName="z-index-preview-backdrop"
        scrollable={false}
      >
        <Modal.Body>
          <div style={{ overflow: "auto" }}>
            <AiNotebookDocumentPreview
              customWidth={customWidth}
              sourceItem={sourceItem}
              fileName={sourceItem?.fileName}
              docTitle={sourceItem?.docTitle}
              searchID={sourceItem?.searchID}
              searchKeyword={""}
              synonyms={[]}
              /*searchID='1a08dc3a4077c024d071f88b33f97c22' */
              showPreview={
                showPreview || showAuthoring
              }
              handleClose={this.handlePreviewClose}
              isOpenAuthoringTab={false}
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  handleKeyWord() {
    //console.log({type: typeof(this.state.item?.keywords)})
    if (typeof (this.state.item?.keywords) == "string") {
      return (
        <div className="details-popup-abstract">
          <h3>Keywords</h3>
          <p>{this.state.item?.keywords}</p>
        </div>
      )
    } else if (typeof (this.state.item?.keywords) == "object") {
      return (
        <div className="details-popup-abstract">
          <h3>Keywords</h3>
          <p>{this.state.item?.keywords?.join("; ")}</p>
        </div>
      )
    } else if (this.state.item?.keypoints) {
      return (
        <div className="details-popup-abstract">
          <h3>Keywords</h3>
          <p>{this.state.item?.keypoints}</p>
        </div>
      )
    }
  }
  handleIsShowMore = (_isShowMore) => {
    this.setState({ isShowMoreAuthor: _isShowMore });
  }
  handleAuthorClick = (authorName) => {
    let url = `/PubMedSearchAuthor?authorName=${authorName}`;
    OpenWindow(url);
  }
  handlCitatedClick = (citation) => {
    if (citation.length > 0) {
      let url = `/PubMedSearchCitations?citedBy=${citation.length}`;
      /*this.props.history.push({
        pathname: url,
        state: citation
      })*/
      sessionStorage.setItem('citationVal', JSON.stringify(citation))
      OpenWindow(url)
    } else return
  }
  render() {
    let url = `/DocURLPubMed?sid=PMS&pmid=${this.state.item?.PMID}`;
    const {
      alertMessageModelColor,
      alertMessageContent,
      alertMessageShowModal,
    } = this.state;
    //console.log({item: this.state})
    return (
      <>
        <div className="pubmed-search-document-container" >
          <div style={{ style: 'border 1px solid' }} className="bg-secondary-50 relative px-3 py-1 pubmed-search-document-selection-wrapper">
            <div className="absolute left-[-6px] top-[-10px]">
              <img
                src={this.state.collapsed ? expandIconNew : collapseIconNew}
                alt="expand/collapse-icon"
                width={14}
                height={14}
                onClick={this.handleExpandCollapse}
                style={{
                  marginTop: this.props.customWidth < 600 ? "35%" : null,
                  cursor: "pointer",
                }}
              />
            </div>
            <div className="pubmed-search-document-selection" >
              <div className="flex min-w-0 pubmed-search-document-selection-left">
                <div className="flex items-center">
                  <label className="group relative max-w-fit inline-flex items-center justify-start cursor-pointer tap-highlight-transparent p-2 select-none">
                    <input
                      type="checkbox"
                      value={this.state.item?.docTitle}
                      key={this.state.item?.rli_id + Math.random()}
                      onChange={() =>
                        this.handelCitationSelect(
                          this.state.documentIndex,
                          this.props.item,
                          this.props.itemTeaser
                        )
                      }
                      checked={this.props.isChecked}
                      style={{ cursor: "pointer", width: "14px", height: "14px" }}
                    />
                  </label>
                </div>
                <div className="min-w-0" style={{ width: '100%' }}>
                  <div ref={(e) => this.props.handleRef(e, this.props.index)} id={this.state.item.title + this.props.selectedTab} className="title-header font-semibold">
                    <div
                      className={this.state.item.genAIEnabled ? "pubmed-search-title-link pubmed-search-ai-enabled" : "pubmed-search-title-link"}
                      style={{ cursor: "pointer" }}
                      id="docdata"
                      //to={{ pathname: url }}
                      //target="_blank"
                      data-title={this.state.item.title}
                      data-docurl={url}
                      onClick={(e) => this.indexPubMedData(e, this.state, url)}
                    >
                      <span style={{ wordBreak: "break-all" }}>{this.state.item.title}</span>
                    </div>
                    {(this.state.item.genAIEnabled) && <>
                      <button
                        type="button"
                        className={`pubmed-search-ai-enable__button`}
                        title="AI Enabled"
                      >
                        <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                        <span className="pubmed-search-review__label">AI Enabled</span>
                      </button>
                    </>}
                  </div>
                  <div className="min-h-20px items-center gap-x-2 text-small lg:flex text-secondary display-bl">
                    {this.state.item.authors &&
                      this.state.item.authors.length > 0 && (
                        <div className="flex min-w-0 items-center max-w-75p">
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="user"
                            className="svg-inline--fa fa-user me-2 opacity-75"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path
                              fill="currentColor"
                              d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"
                            ></path>
                          </svg>
                          <ul className="m-0 flex p-0 overflow-hidden pubmed-search-author-ul">
                            {getVarType(this.state.item.authors) !== "Array" ? (
                              <li className="ml-2 whitespace-nowrap after:ml-2 after:content-['•'] after:last:content-[''] authorItemHover" onClick={x => { this.handleAuthorClick(this.state.item.authors) }}>
                                {this.state.item.authors}
                              </li>
                            ) : (
                              <>
                                {this.state.item.authors.filter((authorItem, authorIndex) => (this.state.isShowMoreAuthor || authorIndex < 5)).map(
                                  (authorItem, authorIndex) => {
                                    return (
                                      <li className="ml-2 whitespace-nowrap after:ml-2 after:content-['•'] after:last:content-[''] authorItemHover" onClick={x => { this.handleAuthorClick(authorItem) }} >
                                        {authorItem}
                                      </li>
                                    );
                                  }
                                )}
                              </>
                            )}
                            {getVarType(this.state.item.authors) === "Array" && this.state.item.authors.length > 5 && <>
                              {this.state.isShowMoreAuthor ?
                                <>
                                  <span className='ml-2 author-show-more-less' onClick={() => this.handleIsShowMore(false)}>
                                    - Authors
                                  </span>
                                </>
                                :
                                <>
                                  <span className='ml-2 author-show-more-less' onClick={() => this.handleIsShowMore(true)}>
                                    + Authors
                                  </span>
                                </>
                              }
                            </>
                            }
                          </ul>
                        </div>
                      )}
                    {/*this.state.item.publicationDate && (
                                    <div className="whitespace-nowrap">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="calendar" className="svg-inline--fa fa-calendar me-2 opacity-75" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z"></path>
                                        </svg>{moment(this.state.item.publicationDate).format("D MMMM YYYY")}
                                    </div>
                                )*/}
                    <div className="flex min-w-0 items-center">
                      {this.state.item.source && this.state.item.source.name && (
                        <div className="source-anchor" >
                          <svg
                            className="svg-inline--fa fa-calendar me-2 opacity-75"
                            width="12px"
                            height="12px"
                            viewBox="0 0 48 48"
                            fill="currentColor"
                            stroke="currentColor"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <defs>
                                <style></style>
                              </defs>
                              <path
                                class="a"
                                d="M39.5,15.5h-9a2,2,0,0,1-2-2v-9h-18a2,2,0,0,0-2,2v35a2,2,0,0,0,2,2h27a2,2,0,0,0,2-2Z"
                              ></path>
                              <line
                                class="a"
                                x1="28.5"
                                y1="4.5"
                                x2="39.5"
                                y2="15.5"
                              ></line>
                            </g>
                          </svg>
                          {this.state.item.doi ? <a
                            href="javascript:void(0)"
                            title={this.state.item.source.name}
                            onClick={(e) => this.handleDOI(this.state.item.doi)}
                            className="source-anchor-style whitespace-nowrap text-inherit !underline"
                          >
                            {this.state.item.source.name}
                          </a> : this.state.item.source.name}
                        </div>
                      )}
                      {this.state.item.publicationDate && (
                        <div className="whitespace-nowrap">
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="calendar"
                            className="svg-inline--fa fa-calendar opacity-75"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path
                              fill="currentColor"
                              d="M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z"
                            ></path>
                          </svg>
                          <span className="ml-2">
                            {moment(this.state.item.publicationDate).format(
                              "D MMMM YYYY"
                            )}
                          </span>
                        </div>
                      )}
                      {this.state.item.doi && (
                        <div className="doi-anchor">
                          <svg
                            className="svg-inline--fa fa-calendar me-2 opacity-75"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_341_498)">
                              <path
                                d="M8.50009 16.8693C13.1223 16.8693 16.8693 13.1222 16.8693 8.50003C16.8693 3.87783 13.1223 0.130798 8.50009 0.130798C3.87789 0.130798 0.130859 3.87783 0.130859 8.50003C0.130859 13.1222 3.87789 16.8693 8.50009 16.8693Z"
                                fill="currentColor"
                              />
                              <path
                                d="M6.51393 11.0577H4.96375V10.4267C4.80635 10.6242 4.43603 10.8256 4.27528 10.9161C3.99399 11.0735 3.61201 11.1759 3.25369 11.1759C2.67435 11.1759 2.15864 10.9929 1.70656 10.5944C1.1674 10.1189 0.914062 9.39189 0.914062 8.60828C0.914062 7.81127 1.19034 7.175 1.74289 6.69947C2.18158 6.32106 2.71804 6.01819 3.28734 6.01819C3.61887 6.01819 4.02773 6.04792 4.31907 6.18857C4.48651 6.26894 4.78626 6.45805 4.96375 6.64223V3.31805H6.51393V11.0577ZM4.92902 8.6133C4.92902 8.31861 4.84817 7.96579 4.64054 7.76151C4.43292 7.55389 4.05546 7.3697 3.76077 7.3697C3.43259 7.3697 3.12857 7.60842 2.91759 7.85624C2.7468 8.05716 2.66141 8.36692 2.66141 8.62478C2.66141 8.88264 2.75829 9.16944 2.92907 9.37036C3.1367 9.61817 3.36035 9.788 3.69188 9.788C3.98992 9.788 4.34441 9.6629 4.54869 9.45863C4.75631 9.25435 4.92902 8.91134 4.92902 8.6133Z"
                                fill="white"
                              />
                              <path
                                d="M13.7869 3.35004C13.5291 3.35004 13.3097 3.44045 13.1289 3.62129C12.9514 3.79877 12.8627 4.01644 12.8627 4.2743C12.8627 4.53216 12.9514 4.7515 13.1289 4.93234C13.3097 5.11317 13.5291 5.20359 13.7869 5.20359C14.0481 5.20359 14.2675 5.11484 14.445 4.93736C14.6258 4.75652 14.7162 4.5355 14.7162 4.2743C14.7162 4.01644 14.6258 3.79877 14.445 3.62129C14.2641 3.44045 14.0448 3.35004 13.7869 3.35004ZM9.70584 5.95104C8.74809 5.95104 8.00968 6.24958 7.49062 6.84667C7.06198 7.3413 6.84766 7.90829 6.84766 8.54777C6.84766 9.25791 7.0603 9.85675 7.4856 10.3443C8.00131 10.9379 8.72465 11.2347 9.65561 11.2347C10.5832 11.2347 11.3049 10.9379 11.8206 10.3443C12.2459 9.85675 12.4585 9.27209 12.4585 8.59021C12.4585 7.9154 12.2442 7.33423 11.8156 6.84667C11.2898 6.24958 10.5866 5.95104 9.70584 5.95104ZM12.9631 6.13237V11.0538H14.6107V6.13237H12.9631ZM9.65561 7.45071C9.957 7.45071 10.2132 7.56217 10.4242 7.78475C10.6385 8.0038 10.7456 8.27224 10.7456 8.59021C10.7456 8.91172 10.6402 9.18365 10.4292 9.40623C10.2182 9.62528 9.96035 9.735 9.65561 9.735C9.31403 9.735 9.03609 9.60065 8.82176 9.33214C8.64763 9.11662 8.56056 8.86932 8.56056 8.59021C8.56056 8.31464 8.64763 8.06908 8.82176 7.85356C9.03609 7.58505 9.31403 7.45071 9.65561 7.45071Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_341_498">
                                <rect width="17" height="17" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>

                          <a
                            href="javascript:void(0)"
                            title={`${this.state.item.doi} (Click this field to view the abstract in doi.org. This will appear in a new browser tab)`}
                            onClick={(e) => this.handleDOI(this.state.item.doi)}
                            className="doi-anchor-style whitespace-nowrap text-inherit !underline"
                          >
                            {this.state.item.doi}
                          </a>
                        </div>
                      )}
                      {this.state.item.citations && (
                        <div className="whitespace-nowrap">
                          <div style={{ cursor: (this.state.item.citation?.length) && 'pointer' }}
                            onClick={() => { this.handlCitatedClick(this.state.item.citations) }}>
                            <label>Cited by:</label>
                            <span>{this.state.item.citations.length}</span>
                          </div>
                        </div>
                      )}

                      {/* {this.state.item.source.name && this.state.item.publicationDate && (


                                   
                                )} */}
                    </div>
                    {/* <a href="https://core.ac.uk/download/518783764.pdf" target="_blank" rel="noreferrer">
                                     <button type="button" tabindex="0" className="z-0 group relative inline-flex items-center justify-center box-border appearance-none select-none whitespace-nowrap font-normal subpixel-antialiased overflow-hidden tap-highlight-transparent data-[pressed=true]:scale-[0.97] outline-none data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 border-medium px-3 min-w-16 h-8 text-tiny gap-2 rounded-small transition-transform-colors-opacity motion-reduce:transition-none bg-transparent border-primary text-primary data-[hover=true]:opacity-hover ms-2">PDF</button>
                                </a> */}
                  </div>
                </div>
              </div>

              <div className="relevant-non-relevant-tag">
                {this.state.item.relevant === "True" ? (
                  <div className="pubmed-search-relevant-outer-box pubmed-search-relevant-outer-box-wrapper">
                    <div className="pubmed-search-relevant-box">
                      <svg
                        fill="#000000"
                        width="12px"
                        height="12px"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21ZM17.737,8.824a1,1,0,0,1-.061,1.413l-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,0,1,1.415-1.414l2.323,2.323,5.294-4.853A1,1,0,0,1,17.737,8.824Z"></path>
                        </g>
                      </svg>
                      <span className="mx-1">Highly Responsive</span>
                    </div>
                    {this.props.item?.FullTextLinks && this.props.item?.FullTextLinks.map((item) => {
                      let title = item?.categories?.length > 0 ? `${item.provider?.name}\n${item.categories[0]}` : `${item.provider?.name}`
                      return (
                        <div className="pubmed-search-fulltext-links-container" title={title}  >
                          <img src={item?.iconurl?.value} alt="" height={23} style={{ cursor: 'pointer' }} onClick={e => window.open(item?.url?.value)} />
                        </div>
                      )
                    })}
                  </div>
                ) : (
                  <div className="pubmed-search-relevant-outer-box pubmed-search-relevant-outer-box-wrapper">
                    <div className="pubmed-search-not-relevant-box">
                      {
                        <svg
                          style={{ marginTop: '2px' }}
                          width="12px"
                          height="12px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <path
                              d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                              fill="#0F0F0F"
                            ></path>{" "}
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                              fill="#0F0F0F"
                            ></path>
                          </g>
                        </svg>
                      }
                      <span className="mx-1">Responsive</span>
                    </div>
                    {this.props.item?.FullTextLinks && this.props.item?.FullTextLinks?.map((item) => {
                      let title = item?.categories?.length > 0 ? `${item.provider?.name}\n${item.categories[0]}` : `${item.provider?.name}`
                      return (
                        <div className="pubmed-search-fulltext-links-container" title={title} >
                          <img src={item?.iconurl?.value} alt="" height={23} style={{ cursor: 'pointer' }} onClick={e => window.open(item?.url?.value)} />
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {!this.state.collapsed && (
          <div className="flex">
            <div className="group relative min-h-10 w-full min-w-[100px] break-words border-r-2 border-secondary-100 px-1 py-3 text-sm first:pl-[40px] last:border-r-0 w-200px fl-anchor-center pubmed-search-citation-left-section">
              {!this.state.isPreviewProcessing ? (
                <b className="pubmed-view-document">
                  <label>
                    <a
                      href="javascript:void(0)"
                      className="pubmed-search-citation-value citation-blue"
                      title="Click this field to view the abstract in PubMed. This will appear in a new browser tab"
                      onClick={(e) =>
                        this.handlePreviewByPubMedID(e, this.state.item.PMID)
                      }
                    >
                      View Document
                    </a>
                  </label>
                  {this.state.item.PMID && (
                    <label>
                      <a
                        href="javascript:void(0)"
                        className="pubmed-search-citation-value citation-blue pubmed-search-citation-pmid"
                        title="Click this field to view the abstract in PubMed. This will appear in a new browser tab"
                        onClick={(e) =>
                          this.handlePubMedID(this.state.item.PMID)
                        }
                      >
                        PMID:{this.state.item.PMID}
                      </a>
                    </label>
                  )}
                  {this.state.item.PMCID && (
                    <label>
                      <a
                        href="javascript:void(0)"
                        className="pubmed-search-citation-value citation-blue pubmed-search-citation-pmcid"
                        title="Click this field to view the abstract in PubMed. This will appear in a new browser tab"
                        onClick={(e) =>
                          this.handlePubMedPMCID(this.state.item.PMCID)
                        }
                      >
                        PMCID:{this.state.item.PMCID}
                      </a>
                    </label>
                  )}
                  {/* {this.props?.tab == 1 && ( */}
                  <label>
                    <a
                      href="javascript:void(0)"
                      className="pubmed-search-citation-value citation-blue view-document-link"
                      //title="Click this field to view the abstract in PubMed. This will appear in a new browser tab"
                      onClick={(e) =>
                        this.setState({
                          ...this.state,
                          documentDetailModal: true,
                        })
                      }
                    >
                      <span>
                        <svg
                          fill="#000000"
                          className="svg-inline--fa fa-calendar opacity-75"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <path
                              fill-rule="evenodd"
                              d="M19,14 L19,19 C19,20.1045695 18.1045695,21 17,21 L5,21 C3.8954305,21 3,20.1045695 3,19 L3,7 C3,5.8954305 3.8954305,5 5,5 L10,5 L10,7 L5,7 L5,19 L17,19 L17,14 L19,14 Z M18.9971001,6.41421356 L11.7042068,13.7071068 L10.2899933,12.2928932 L17.5828865,5 L12.9971001,5 L12.9971001,3 L20.9971001,3 L20.9971001,11 L18.9971001,11 L18.9971001,6.41421356 Z"
                            ></path>
                          </g>
                        </svg>
                      </span>
                      <span>Details</span>
                    </a>
                  </label>
                  {/* )} */}
                </b>
              ) : (
                <div className="pubmed-search-loader">
                  <img src={imsLoader} alt="" height={19} />
                </div>
              )}
            </div>
            <div className="group relative min-h-10 w-full min-w-[100px] break-words border-secondary-100 px-1 py-3 text-sm first:pl-[40px] last:border-r-0">
              {this.state.item.summary ? (
                <b>
                  <label className="pubmed-search-citation-value">
                    AI Summary:{" "}
                    <span className="citation-summary">
                      {this.state.item.summary}
                    </span>
                  </label>
                </b>
              ) : (this.state.item.hasAbstract) && (
                <b>
                  <label className="pubmed-search-citation-value">
                    Abstract:{" "}
                    <span className="citation-summary">
                      {this.state.item.body}
                    </span>
                  </label>
                </b>
              )}
            </div>
          </div>
        )}
        {this.renderModelPopup()}
        {alertMessageShowModal && (
          <AlertMessagePopUpModal
            color={alertMessageModelColor}
            content={alertMessageContent}
            showModal={alertMessageShowModal}
            handleClose={() => this.closeAlertMessage()}
          />
        )}

        {/* view document details */}
        <Modal
          show={this.state.documentDetailModal}
          size="xl"
          onHide={() =>
            this.setState({
              ...this.state,
              documentDetailModal: false,
            })
          }
          centered
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="authoring-popup-transition"
          className="z-index-preview"
          backdropClassName="z-index-preview-backdrop"
          scrollable={false}
          contentClassName="min-height-class"
        >
          <Modal.Header>
            <Modal.Title>
              <div>
                <p className="details-popup-title"
                  onClick={(e) => this.indexPubMedData(e, this.state, url)}
                >
                  {this.state.item?.title}
                </p>
                <div className="popup-cancel-btn-wrapper">
                  <img
                    src={popCancelBttn}
                    alt=""
                    onClick={(e) => {
                      this.setState({
                        ...this.state,
                        documentDetailModal: false,
                      });
                    }}
                  />
                </div>
                <p className="details-popup-authors">
                  {Array.isArray(this.state.item?.authors) &&
                    this.state.item?.authors?.join(", ")}
                </p>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="details-popup-body-container">
              <p>{this.state.item?.source?.name}</p>
              <div className="details-popup-metadata-container">
                <div>
                  <p className="details-popup-metadata-publicationDate">
                    {moment(this.state.item.publicationDate).format(
                      "D MMMM YYYY"
                    )}
                  </p>
                  <p
                    className="details-popup-metadata-doi"
                    onClick={() => this.handleDOI(this.state.item?.doi)}
                  >
                    <span className="details-popup-metadata-doi-span1">
                      DOI:
                    </span>
                    <span className="details-popup-metadata-doi-span2">
                      {this.state.item?.doi}
                    </span>
                  </p>
                </div>
                <div className="details-popup-metadata-pmid-view-document-container">
                  {this.state.item?.PMID && (
                    <>
                      <p className="details-popup-metadata-pmid">
                        <span className="details-popup-metadata-pmid-span1">
                          PMID:
                        </span>{" "}
                        <span onClick={(e) =>
                          this.handlePubMedID(this.state.item.PMID)
                        } className="details-popup-metadata-pmid-span2">
                          {this.state.item?.PMID}
                        </span>
                      </p>
                      <p
                        className="details-popup-metadata-view-document"
                        onClick={(e) =>
                          this.handlePreviewByPubMedID(e, this.state.item.PMID)
                        }
                      >
                        View Document
                      </p>
                    </>
                  )}
                </div>
              </div>

              {this.state.item?.relevant === "True" &&
                this.state.item?.summary && (
                  <div className="details-popup-aisummary">
                    <h3>AI Summary</h3>
                    <p>{this.state.item?.summary}</p>
                  </div>
                )}

              {this.state.item?.body && (
                <div className="details-popup-abstract">
                  <h3>Abstract</h3>
                  <p>{this.state.item?.body}</p>
                </div>
              )}

              {this.handleKeyWord()}

            </div>
          </Modal.Body>

          <div className="pubmed-upload-abstracts-close-button-wrapper">
            <Button
              text="Close"
              customColor="#0074B0"
              action={() => {
                this.setState({
                  ...this.state,
                  documentDetailModal: false,
                });
              }}
            />
          </div>
        </Modal>
      </>
    );
  }
}
export default PubMedDocumentCard;
